import {
  searchBriefs,
  refineSearchBriefs,
  fetchRecentUpdates,
  refineRecentUpdateSearch,
} from '../api';
import { runFilterUpdate, augumentFilters } from '../utils/searchhelpers';
import { clearBriefSelectionAction } from '../actions/briefSelectionActions';
import {
  updateFacets,
  facetSearchWithAreaFilter,
  facetResetAction,
} from '../store/actions/facetActions';

import { actionCreators as usageLogActions } from '../actions/usagelogging';
import { getTokenForUser } from '../utils/helpers';

const newSearchStarted = (phrase, selectedAreaFilter) => ({
  type: 'SEARCH_NEW_STARTED',
  phrase,
  selectedAreaFilter,
});

const newRecentContentSearchStarted = () => ({
  type: 'SEARCH_NEW_RECENT_CONTENT_STARTED',
});

export const searchCompleted = (data, selectedAreaFilter = null) => ({
  type: 'SEARCH_RESULTS_RECIEVED',
  data,
  selectedAraFilter: selectedAreaFilter,
  searchPhraseChanged: false,
});

const searchWithAreaFilterCompleted = (data, selectedAreaFilter = null) => ({
  type: 'SEARCH_RESULTS_WITH_AREA_FILTER_RECEIVED',
  data,
  selectedAreaFilter,
});

const pagingStarted = (pageNumber) => ({
  type: 'SEARCH_FETCH_PAGE_STARTED',
  pageNumber,
});

const fetchPageCompleted = (data) => ({
  type: 'SEARCH_PAGE_FETCHED',
  data,
});

const searchSortChangeStarted = (sortBy, pageSize, currentPage) => ({
  type: 'SEARCH_SORT_STARTED',
  sortBy,
  pageSize,
  currentPage,
});

const searchSortCompleted = (data, pageSize) => ({
  type: 'SEARCH_SORT_COMPLETED',
  data,
  pageSize: pageSize,
  endIndex: pageSize,
});

const changePageSizeStarted = (pageSize) => ({
  type: 'SEARCH_PAGE_SIZE_STARTED',
  pageSize: pageSize,
  endIndex: pageSize,
});

const changePageSizeCompleted = (data, pageSize) => ({
  type: 'SEARCH_PAGE_SIZE_COMPLETED',
  data,
  pageSize,
});

export const searchRefinementChangeStarted = (newFilters) => ({
  type: 'SEARCH_FILTER_CHANGE_STARTED',
  newFilters,
});

const searchRefinementCompleted = (data, area) => ({
  type: 'SEARCH_FILTER_CHANGE_COMPLETED',
  data,
  area,
});

const searchResetAction = () => ({
  type: 'SEARCH_RESET',
});

const searchNoResult = () => ({
  type: 'SEARCH_NO_RESULT',
});

export const searchSelectedAreaFilterReset = () => ({
  type: 'SEARCH_SELECTED_AREA_FILTER_RESET',
});

const actionCreators = {
  searchReset: () => (dispatch) => {
    dispatch(searchResetAction());
  },
  searchWithAreaFilter: (user = null, phrase, sortBy, areaFilter = null) => (
    dispatch,
    getState
  ) => {
    dispatch(newSearchStarted(phrase, areaFilter));
    dispatch(clearBriefSelectionAction);

    const initialFilters = {};

    initialFilters[areaFilter.name] = [
      {
        key: { id: areaFilter.id, title: areaFilter.title },
        selected: true,
      },
    ];

    return refineSearchBriefs(
      phrase,
      initialFilters,
      getTokenForUser(user),
      sortBy
    ).then((resp) => {      
      const augmentedFilters = augumentFilters(resp.data);

      (augmentedFilters[areaFilter.name] || []).forEach((f) => {
        if (f.key.id === areaFilter.id) {
          f.selected = true;
        }
      });

      resp.data.filters = augmentedFilters;

      dispatch(searchWithAreaFilterCompleted(resp.data, areaFilter));
      dispatch(facetSearchWithAreaFilter());

      dispatch(
        usageLogActions.logAnalytics({
          category: areaFilter.name,
          action: 'Home Page Click',
          label: areaFilter.title,
        })
      );

      updateFacets(dispatch, getState, resp.data.filters, {
        area: areaFilter.name,
        id: areaFilter.id,
        newValue: true,
      });
    });
  },

  startSearch: (user, sortBy, location, currentPhrase, params) => (
    dispatch,
    getState
  ) => {
    const SEARCH_WITH_AREA_FILTER = 1;
    const USER_INITIATED_SEARCH = 2;
    const SEARCH_PHRASE_IS_NOT_PROVIDED = 0;

    const { searchPhrase } = getState().search;

    const { areaFilter = null } = location.state || {};

    if (currentPhrase === null || currentPhrase === '') {
      return SEARCH_PHRASE_IS_NOT_PROVIDED;
    }

    if (areaFilter) {
      dispatch(
        actionCreators.searchWithAreaFilter(
          user,
          currentPhrase,
          sortBy,
          areaFilter
        )
      );
      location.state.areaFilter = null; // clear the area filter to prevent infinite loop.
      return SEARCH_WITH_AREA_FILTER;
    }

    if (currentPhrase !== searchPhrase && areaFilter === null) {
      dispatch(
        actionCreators.startNewSearch(user, currentPhrase, sortBy, params)
      );
      dispatch(usageLogActions.ranSearch(user, currentPhrase));
      return USER_INITIATED_SEARCH;
    }
  },

  startNewSearch: (user, phrase, sortBy, params) => (dispatch, getState) => {
    dispatch(newSearchStarted(phrase));
    dispatch(facetResetAction());
    dispatch(clearBriefSelectionAction);
    const initialFilters = {};
    let filterType = params && params.ca ? 'clinicalAreas' : null;
    let content = [];
    let typeFilter = [];

    if (filterType) {
      let ids = params.ca.split('|');
      ids.forEach((id) => {
        content.push({
          key: { id: id, title: '' },
          selected: true,
        });
        typeFilter.push({
          name: filterType,
          id: id,
          title: '',
        });
      });
      initialFilters[filterType] = content;

      return refineSearchBriefs(
        phrase,
        initialFilters,
        getTokenForUser(user),
        sortBy
      ).then((resp) => {        
        const augmentedFilters = augumentFilters(resp.data);
        typeFilter.forEach((filter) => {
          (augmentedFilters[filter.name] || []).forEach((f) => {
            if (f.key.id === filter.id) {
              f.selected = true;
            }
          });
        });

        resp.data.filters = augmentedFilters;
        dispatch(searchWithAreaFilterCompleted(resp.data, null));
        dispatch(facetSearchWithAreaFilter());
        typeFilter.forEach((x) => {
          updateFacets(dispatch, getState, resp.data.filters, {
            area: x.name,
            id: x.id,
            newValue: true,
          });
        });
      });
    }
    
    return searchBriefs(phrase, getTokenForUser(user), sortBy)
      .then((resp) => {
        const augmentedFilters = augumentFilters(resp.data);
        resp.data.filters = augmentedFilters;
        dispatch(searchCompleted(resp.data, null));
      })
      .catch((err) => {
        if (err.response) {
          dispatch(searchNoResult());
          console.log(err);
        }
      });
  },

  startNewRecentContentSearch: (user) => (dispatch) => {
    dispatch(newRecentContentSearchStarted());
    dispatch(facetResetAction());
    fetchRecentUpdates(getTokenForUser(user), 0, 9).then((resp) => {
      dispatch(searchCompleted(resp.data));
    });
  },

  fetchPage: (pageData) => (dispatch, getState) => {
    const { oidc, search } = getState();
    const { searchPhrase, filters, isRecentContentSearch, sortBy } = search;
    dispatch(pagingStarted(pageData.currentPage));
    let apiPromise;

    if (isRecentContentSearch) {
      apiPromise = refineRecentUpdateSearch(
        filters,        
        getTokenForUser(oidc.user),
        pageData.startIndex,
        pageData.endIndex
      );
    } else {
      apiPromise = refineSearchBriefs(
        searchPhrase,
        filters,        
        getTokenForUser(oidc.user),
        sortBy,
        pageData.startIndex,
        pageData.endIndex
      );
    }

    apiPromise.then((resp) => {
      dispatch(fetchPageCompleted(resp.data));
    });
  },

  changeSortDirection: (sortBy) => (dispatch, getState) => {
    const { oidc, search } = getState();
    const {
      searchPhrase,
      filters,
      startIndex,
      endIndex,
      pageSize,
      currentPage,
    } = search;

    dispatch(searchSortChangeStarted(sortBy, pageSize, currentPage));

    refineSearchBriefs(
      searchPhrase || '*',
      filters,      
      getTokenForUser(oidc.user),
      sortBy,
      startIndex,
      endIndex
    ).then((resp) => {
      dispatch(searchSortCompleted(resp.data));
    });
  },

  changePageSize: (pageSize) => (dispatch, getState) => {
    const { oidc, search } = getState();
    const { searchPhrase, filters, sortBy } = search;
    dispatch(changePageSizeStarted(+pageSize));

    refineSearchBriefs(
      searchPhrase || '*',
      filters,      
      getTokenForUser(oidc.user),
      sortBy,
      0,
      +pageSize
    ).then((resp) => {
      dispatch(changePageSizeCompleted(resp.data, +pageSize));
    });
  },

  updateRefiners: (filterUpdate) => (dispatch, getState) => {
    const { oidc, search } = getState();
    const { area, id, newValue } = filterUpdate;
    
    const updatedFilter = runFilterUpdate(
      area,
      id,
      newValue,
      search.filters,
      dispatch
    );

    dispatch(searchRefinementChangeStarted(updatedFilter));

    dispatch(clearBriefSelectionAction);

    updateFacets(dispatch, getState, search.filters, filterUpdate);

    const { searchPhrase, sortBy, isRecentContentSearch } = search;
    let apiPromise;
    if (isRecentContentSearch) {
      apiPromise = refineRecentUpdateSearch(
        updatedFilter,        
        getTokenForUser(oidc.user)
      );
    } else {
      apiPromise = refineSearchBriefs(
        searchPhrase,
        updatedFilter,        
        getTokenForUser(oidc.user),
        sortBy
      );
    }
    apiPromise.then((resp) => {
      dispatch(searchRefinementCompleted(resp.data, area));
    });
  },
};

export default actionCreators;
